import { useLocation } from '@tanstack/react-router'
import { useDocumentTitle } from '@/lib/hooks/useDocumentTitle'

const STATIC_ROUTE_TITLES: Record<string, string> = {
  '/auth/callback': 'Signing in',
  '/branding': 'Branding',
  '/chat': 'Chat',
  '/checkins': 'Check-ins',
  '/clients': 'Clients',
  '/dashboard': 'Dashboard',
  '/exercises': 'Exercises',
  '/foods': 'Foods',
  '/forgot': 'Forgot password',
  '/forms': 'Forms',
  '/getting-started': 'Getting started',
  '/habits': 'Habits',
  '/join': 'Join',
  '/leads': 'Leads',
  '/login': 'Login',
  '/meals': 'Meals',
  '/metrics': 'Metrics',
  '/nutrition': 'Nutrition',
  '/oauth/consent': 'Authorize app',
  '/packages': 'Packages',
  '/refer': 'Refer',
  '/register': 'Register',
  '/reset-password': 'Reset password',
  '/settings': 'Settings',
  '/settings/organisation': 'Organisation',
  '/settings/security': 'Security',
  '/settings/subscription': 'Subscription',
  '/setup': 'Setup',
  '/supplements': 'Supplements',
  '/team': 'Team',
  '/training': 'Training',
  '/upgrade': 'Upgrade',
  '/vault': 'Vault',
  '/workout-session': 'Workout session',
  '/workouts': 'Workouts',
}

function getRouteTitle(pathname: string) {
  if (pathname === '/') {
    return null
  }

  if (STATIC_ROUTE_TITLES[pathname]) {
    return STATIC_ROUTE_TITLES[pathname]
  }

  if (/^\/clients\/[^/]+/.test(pathname)) {
    return 'Client'
  }
  if (/^\/forms\/[^/]+/.test(pathname)) {
    return 'Form'
  }
  if (/^\/leads\/[^/]+/.test(pathname)) {
    return 'Lead'
  }
  if (/^\/nutrition\/[^/]+/.test(pathname)) {
    return 'Meal plan'
  }
  if (/^\/training\/[^/]+/.test(pathname)) {
    return 'Training plan'
  }
  if (/^\/workouts\/[^/]+/.test(pathname)) {
    return 'Workout'
  }

  return null
}

export default function DocumentTitleManager() {
  const { pathname } = useLocation()

  useDocumentTitle(getRouteTitle(pathname), { priority: 0 })

  return null
}
